import styled from "@emotion/styled";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { Nok, PatchNokParams } from "../../types/types";
import SelectBox, { menuItemType } from "../selectBox";
import theme from "../../theme";
import useGetAllCustomer from "../../hooks/useGetAllCustomer";
import { Label } from "../common/Label";
import { TextInput } from "../common/TextInput";
import { isOnlyNumber } from "../../utils/util";
import { useI18n } from "../../locales";

const { sm } = theme.screen;

const InputField: React.FC<{
  form: PatchNokParams;
  setForm: Dispatch<SetStateAction<PatchNokParams>>;
  data: Nok;
}> = (props) => {
  const { form, setForm, data } = props;
  const { t } = useI18n();

  // 사용자 연락처 리스트 가져오기
  const { data: relatedIdList } = useGetAllCustomer({
    page: 0,
    searchKey: "",
    area: "",
    limit: -1,
  });
  let relatedIdListType: menuItemType[] = [
    {
      value: -1,
      title: t.manageNok.selectOwner,
    },
  ];
  if (relatedIdList) {
    relatedIdList.list.filter((item) => {
      relatedIdListType.push({
        value: item.id,
        title: item.seq + ". " + item.name,
      });
    });
  }

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // 보호자 연락처 유효성 검사
    if (name == "nok_phone") {
      // "-" 제외 숫자만 최대 11자리까지 가능
      if (value.replaceAll("-", "").length > 11) {
        return;
      }
      // 숫자와 '-'만 입력 가능
      if (!isOnlyNumber(value.replaceAll("-", ""))) {
        return;
      }
    }

    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const isIdErr = form.id.length > 0 && !isOnlyNumber(form.id);

  return (
    <UserInfoWrapper>
      <UserInfo>
        <RowContainer>
          {/* 사용자명 & 사용자 연락처 */}
          <InputWrapper>
            <Label text={t.manageNok.nameLabel} htmlFor="nok_name" isRequired />
            <TextInput
              autoComplete="off"
              id="nok_name"
              name="nok_name"
              width={"100%"}
              onChange={handleChange}
              value={form.nok_name}
              placeholder={t.manageNok.maxCharacters}
              maxLength={20}
            />
          </InputWrapper>
          <InputWrapper style={{ position: "relative" }}>
            <Label text={t.manageNok.contactLabel} htmlFor="nok_phone" isRequired />

            <TextInput
              autoComplete="off"
              id="nok_phone"
              name="nok_phone"
              width={"100%"}
              onChange={handleChange}
              value={form.nok_phone}
            />
            {<PwError>{t.manageNok.includeDash}</PwError>}
          </InputWrapper>

          <InputWrapper>
            <Label
              text={t.manageNok.relationshipLabel}
              htmlFor="relation"
              isRequired
            />

            <TextInput
              autoComplete="off"
              id="relation"
              name="relation"
              width={"100%"}
              onChange={handleChange}
              value={form.relation}
              placeholder={t.manageNok.maxCharacters}
              maxLength={20}
            />
          </InputWrapper>

          <InputWrapper>
            <Label text={t.manageNok.ownerLabel} htmlFor="related_id" />

            <SelectBox
              disabled
              filter={data.related_id}
              menuItems={relatedIdListType}
              width={"100%"}
              srLabel={t.manageNok.ownerLabel}
            />
          </InputWrapper>
        </RowContainer>
      </UserInfo>
    </UserInfoWrapper>
  );
};

const UserInfoWrapper = styled.div`
  background: ${theme.color.neutral_50};
  border-radius: 10px;
  padding-left: 40px;
  padding-right: 30px;
  padding-top: 30px;
  padding-bottom: 40px;
  width: 100%;
  display: flex;
  gap: 44px;
  margin-bottom: 40px;
  @media (max-width: ${sm}px) {
    padding: 10px;
    padding-bottom: 20px;
  }
`;

const UserInfo = styled.div`
  width: 100%;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const PwError = styled.p`
  font-size: 10px;
  color: ${theme.color.neutral_500};
  /* position: absolute; */
  /* bottom: -30px; */
  left: 3px;
  width: 200px;
  padding-top: 10px;
  padding-left: 10px;
`;

const RowContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 26px;
`;
export default InputField;
